import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { UiServices } from 'src/app/services/ui-services';
import { DropdownService } from 'src/app/services/dropdown.service';

@Component({
  selector: 'app-opts-menu',
  templateUrl: './opts-menu.component.html',
  styleUrls: ['./opts-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OptsMenuComponent implements OnInit {
  @Input() set menu(value: any[]) {
    if (value && value.length) {
      this.optsMenu = value;
      this._cdr.detectChanges();
    }
  }
  @Input() search: string = '';
  public childBottomPosition = false;
  public leftPosition = false;
  public optsMenu = [];

  constructor(
    private _cdr: ChangeDetectorRef,
    public uiSv: UiServices,
    public dropdownSv: DropdownService
  ) {}

  ngOnInit() {}

  setDefaultAxis() {
    this.childBottomPosition = false;
    this.leftPosition = false;
  }
}
